import { withStyles } from '@material-ui/core'

import { EditPage as View } from './EditPage'
import { styles } from './styles'

// @ts-ignore
export const EditPage = withStyles(styles)(View)
